if (window.PopoverComponent !== undefined) PopoverComponent.init({
    ele: '.popover-demo',
    position: 'top',
    showOnHover: true,
    hideArrowIcon: false,
  });